module.exports = __webpack_public_path__ + "media/images/v2/share-dcc96313d60e214d975fad22b2d68008.png";